export default __webpack_public_path__ + "static/media/server.cea7eb12.svg";